// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collections-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.collections-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 10;
}

.header-left,
.header-right {
  flex: 1 1;
  display: flex;
  align-items: center;
}

.header-right {
  justify-content: flex-end;
}

.collections-header h1 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
  text-align: center;
  flex: 2 1;
}

.back-button {
  background: none;
  border: none;
  color: #007bff;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  padding: 0.5rem 0;
}

.back-button:hover {
  color: #0056b3;
  text-decoration: underline;
}

.logout-button {
  background: none;
  border: none;
  color: #dc3545;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
}

.logout-button:hover {
  color: #c82333;
  text-decoration: underline;
}

.collections-content {
  flex: 1 1;
  padding: 2rem;
  max-width: 1500px;
  margin: 0 auto;
  width: 100%;
}

.collections-search {
  margin-bottom: 1.5rem;
}

/* New filter styles */
.collections-filters {
  margin-bottom: 1.5rem;
}

.filter-options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 1rem;
  gap: 1rem;
}

.filter-button {
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  color: #495057;
  font-size: 0.9rem;
}

.filter-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.customer-filter-button {
  background-color: #e9f2ff;
  border-color: #b8daff;
  color: #0062cc;
}

.customer-filter-button:hover {
  background-color: #cce5ff;
  border-color: #8bbeff;
}

.date-filter-button {
  background-color: #e9fff2;
  border-color: #b8ffd9;
  color: #00a67c;
}

.date-filter-button:hover {
  background-color: #ccffe7;
  border-color: #8bffcc;
}

/* Add styles for sort order button */
.sort-order-button {
  background-color: #f2e9ff;
  border-color: #d9b8ff;
  color: #6200cc;
}

.sort-order-button:hover {
  background-color: #e7ccff;
  border-color: #cc8bff;
}

.active-filter {
  display: flex;
  align-items: center;
  background-color: #e9f2ff;
  border: 1px solid #b8daff;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #0062cc;
}

.active-filter.date-filter {
  background-color: #e9fff2;
  border-color: #b8ffd9;
  color: #00a67c;
}

.active-filters-summary {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #007bff;
  font-size: 0.9rem;
  color: #495057;
}

.active-filters-summary p {
  margin: 0;
}

.filter-action-buttons {
  display: inline-flex;
  gap: 10px;
  margin-left: 15px;
}

.clear-filter-button {
  background: rgba(108, 117, 125, 0.1);
  border: none;
  color: #6c757d;
  cursor: pointer;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.clear-filter-button:hover {
  background-color: rgba(108, 117, 125, 0.2);
  color: #495057;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  backdrop-filter: none;
}

.customer-modal {
  max-width: 600px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 0;
}

.date-filter-modal {
  max-width: 500px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 0;
}

.modal-header {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  background-color: #fff;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  color: #333;
}

.modal-close-button {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #6c757d;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.modal-close-button:hover {
  color: #343a40;
}

.customer-search-container {
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.date-filter-container {
  padding: 20px;
  background-color: white;
}

.date-input-group {
  margin-bottom: 20px;
}

.date-input-group label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #495057;
}

.date-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

.date-input:focus {
  border-color: #00a67c;
  box-shadow: 0 0 0 0.2rem rgba(0, 166, 124, 0.25);
}

.date-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.date-filter-button {
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.date-filter-button.secondary {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #ced4da;
}

.date-filter-button.secondary:hover {
  background-color: #e9ecef;
  color: #495057;
}

.date-filter-button.primary {
  background-color: #00a67c;
  color: white;
}

.date-filter-button.primary:hover {
  background-color: #00916c;
}

.customers-list {
  padding: 0;
  overflow-y: auto;
  max-height: 400px;
  background-color: white;
}

.customer-item {
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  transition: background-color 0.2s;
}

.customer-item:hover {
  background-color: #f8f9fa;
}

.customer-item:last-child {
  border-bottom: none;
  margin-bottom: 10px;
}

.customer-name {
  font-weight: 500;
  color: #212529;
}

.customer-code {
  color: #6c757d;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

.no-customers {
  padding: 30px 20px;
  text-align: center;
  color: #6c757d;
  font-style: italic;
}

.search-wrapper {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
}

.clear-search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  cursor: pointer;
  transition: color 0.2s;
}

.clear-search-icon:hover {
  color: #6c757d;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
  padding-right: 2.5rem;
}

.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.collections-list {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
  max-width: 100%;
}

/* New table styles */
.collections-table-container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  max-width: 100%;
  margin-bottom: 1.5rem;
  padding: 2px;
  min-width: 1000px;
}

.collections-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: auto;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  font-size: 0.85rem;
}

.collections-table thead tr {
  background-color: #f2f2f2;
  border-bottom: 2px solid #ddd;
}

.collections-table th {
  padding: 6px 8px;
  font-weight: bold;
  text-align: center;
  position: sticky;
  top: 0;
  background-color: #f2f2f2;
  z-index: 1;
  border-right: 1px solid #ddd;
  box-shadow: 0 1px 0 0 #ddd;
  min-width: 80px;
}

.collections-table th:first-child {
  border-left: 1px solid #ddd;
}

.collections-table tbody tr {
  border-bottom: 1px solid #ddd;
}

.collections-table tbody tr:nth-child(even) {
  background-color: #f8f8f8;
}

.collections-table tbody tr:hover {
  background-color: #eaf3ff;
}

.collections-table td {
  padding: 10px 15px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  font-size: 16px;
  font-weight: 500;
  color: #181818;
}

.collections-table td:first-child {
  border-left: 1px solid #ddd;
}

/* Column widths */
.collections-table th:nth-child(1),
.collections-table td:nth-child(1) {
  min-width: 50px;
  text-align: center;
}

.collections-table th:nth-child(2),
.collections-table td:nth-child(2) {
  min-width: 150px;
  white-space: nowrap;
}

.collections-table th:nth-child(3),
.collections-table td:nth-child(3) {
  min-width: 80px;
  text-align: right;
}

.collections-table th:nth-child(4),
.collections-table td:nth-child(4) {
  min-width: 55px !important;
  max-width: 55px !important;
  width: 55px !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.collections-table th:nth-child(5),
.collections-table td:nth-child(5) {
  min-width: 140px;
  text-align: left;
}

.collections-table th:nth-child(n+6):nth-child(-n+14),
.collections-table td:nth-child(n+6):nth-child(-n+14) {
  min-width: 90px;
  white-space: nowrap;
  text-align: right;
}

.collections-table th:nth-child(15),
.collections-table td:nth-child(15) {
  min-width: 60px;
  text-align: center;
}

/* Keep the collection-header and collection-item rules for backward compatibility */
.collection-header {
  display: flex;
  background-color: #f1f3f5;
  padding: 1rem;
  font-weight: bold;
  border-bottom: 1px solid #dee2e6;
  position: sticky;
  top: 0;
  z-index: 1;
  min-width: max-content;
}

.collection-item {
  display: flex;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s;
  min-width: max-content;
}

.collection-item:hover {
  background-color: #f8f9fa;
}

.collection-item:last-child {
  border-bottom: none;
}

.collection-column {
  min-width: 100px;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.collection-column:nth-child(1) {
  min-width: 90px;
}

.collection-column:nth-child(2) {
  min-width: 150px;
}

.collection-column:nth-child(3) {
  min-width: 130px;
}

.collection-column:nth-child(4),
.collection-column:nth-child(5),
.collection-column:nth-child(6),
.collection-column:nth-child(7),
.collection-column:nth-child(8),
.collection-column:nth-child(9) {
  min-width: 80px;
}

.collection-column:nth-child(10),
.collection-column:nth-child(11),
.collection-column:nth-child(12),
.collection-column:nth-child(13) {
  min-width: 90px;
}

.error-message {
  text-align: center;
  padding: 2rem;
  color: #dc3545;
  background-color: #f8d7da;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.error-message button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin-top: 1rem;
  cursor: pointer;
}

.error-message button:hover {
  background-color: #c82333;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #007bff;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.no-collections {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
  font-style: italic;
}

.load-more {
  text-align: center;
  margin: 2rem 0;
}

.load-more-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s;
  margin-bottom: 1rem;
}

.load-more-button:hover {
  background-color: #0069d9;
}

.load-custom-options {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.5rem;
}

.load-custom-button {
  background-color: #f8f9fa;
  color: #007bff;
  border: 1px solid #007bff;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.load-custom-button:hover {
  background-color: #007bff;
  color: white;
}

.collections-footer {
  padding: 1rem;
  text-align: center;
  background-color: #fff;
  border-top: 1px solid #e9ecef;
  color: #6c757d;
  font-size: 0.9rem;
}

/* Responsive styles */
@media (max-width: 1500px) {
  .collections-table-container {
    min-width: 1200px;
  }
}

@media (max-width: 1200px) {
  .collections-content {
    max-width: 100%;
    padding: 1.5rem;
  }
  
  .collections-table-container {
    min-width: 1000px;
  }
}

@media (max-width: 768px) {
  .collections-header {
    padding: 1rem;
  }
  
  .collections-content {
    padding: 1rem;
  }
  
  .collections-table-container {
    min-width: 900px;
    border-radius: 6px;
  }
  
  .collections-table th,
  .collections-table td {
    padding: 8px 10px;
    font-size: 0.9rem;
  }
  
  .collection-header,
  .collection-item {
    font-size: 0.85rem;
  }
  
  .collections-header h1 {
    font-size: 1.2rem;
  }
}

/* Print styles for exporting to PDF/printing */
@media print {
  .collections-table-container {
    overflow: visible;
    width: 100%;
    box-shadow: none;
  }
  
  .collections-table {
    width: 100%;
    border: 1px solid #000;
  }
  
  .collections-table th,
  .collections-table td {
    border: 1px solid #000;
  }
  
  .collections-header,
  .collections-footer,
  .collections-search,
  .load-more {
    display: none;
  }
}

/* Table action column styling */
.actions-cell {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  min-width: 100px;
}

/* Edit Button in Collection Table */
.edit-button {
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 14px;
}

.edit-button:hover {
  background-color: #2980b9;
}

/* Delete Button in Collection Table */
.delete-button {
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 14px;
}

.delete-button:hover {
  background-color: #c0392b;
}

.delete-button:disabled {
  background-color: #e57373;
  cursor: not-allowed;
}

/* Confirmation Modal Styles */
.confirmation-modal {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px;
  overflow: hidden;
}

.confirmation-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.confirmation-modal .modal-header h3 {
  margin: 0;
  color: #e74c3c;
  font-size: 1.25rem;
}

.confirmation-modal .modal-body {
  padding: 20px;
}

.confirmation-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  gap: 10px;
}

.collection-delete-info {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 15px;
  margin: 15px 0;
  border-left: 4px solid #e74c3c;
}

.collection-delete-info p {
  margin: 5px 0;
  font-size: 15px;
}

.warning-text {
  color: #e74c3c;
  font-weight: 500;
  margin-top: 10px;
}

.cancel-button {
  background-color: #f8f9fa;
  color: #3c4043;
  border: 1px solid #dadce0;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.cancel-button:hover {
  background-color: #f1f3f4;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);
}

.cancel-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Edit Collection Modal */
.edit-collection-modal {
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.edit-collection-container {
  padding: 15px;
  background-color: #fff;
}

.edit-form-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.edit-form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.edit-form-input {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.edit-form-input.error {
  border-color: #e74c3c;
}

.edit-input-error {
  color: #e74c3c;
  font-size: 12px;
  margin-top: 5px;
}

.edit-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.edit-form-button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-form-button.cancel {
  background-color: #f1f1f1;
  color: #333;
}

.edit-form-button.save {
  background-color: #27ae60;
  color: white;
}

.edit-form-button.cancel:hover {
  background-color: #e5e5e5;
}

.edit-form-button.save:hover {
  background-color: #219653;
}

.edit-form-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.edit-form-error {
  background-color: #ffebee;
  color: #c62828;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.calculation-results {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
  margin-top: 10px;
}

.calculation-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}

.calculation-item label {
  font-weight: 500;
  min-width: 70px;
}

.calculation-item span {
  font-weight: 600;
  color: #2c3e50;
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Edit Form Button - Preview Button */
.edit-form-button.preview {
  background-color: #00a67c;
  color: white;
}

.edit-form-button.preview:hover {
  background-color: #00916c;
}

/* Preview Modal Styles */
.preview-modal {
  width: 95%;
  max-width: 1400px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.preview-modal .modal-body {
  padding: 20px 30px;
  max-height: 60vh;
  overflow-y: auto;
}

.preview-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px;
  border-top: 1px solid #e8eaed;
  background-color: #f8f9fa;
  gap: 15px;
}

.preview-header {
  background-color: #f0f7ff;
  padding: 15px 20px;
  border-radius: 6px;
  border-left: 4px solid #1976d2;
  margin-bottom: 20px;
}

.preview-info {
  font-size: 18px;
  color: #424242;
  margin: 0;
  line-height: 1.6;
}

.preview-table-container {
  overflow-x: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.preview-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 16px;
  line-height: 1.6;
}

.preview-table th,
.preview-table td {
  padding: 16px 24px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  white-space: nowrap;
}

/* Add alternating row colors for better readability */
.preview-table tbody tr:nth-child(even) {
  background-color: #f5f9ff;
}

.preview-table tbody tr:hover {
  background-color: #eaf0fb;
}

/* Improve column spacing with min-width */
.preview-table th {
  background-color: #f0f5fa;
  font-weight: 600;
  color: #444;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 2px solid #ddd;
  min-width: 100px;
  font-size: 17px;
}

/* Increase font size for table data */
.preview-table td {
  font-size: 16px;
  font-weight: 500;
}

/* Ensure certain columns have proper width */
.preview-table th:nth-child(1), /* Customer name */
.preview-table td:nth-child(1) {
  min-width: 150px;
}

.preview-table th:nth-child(2), /* Date */
.preview-table td:nth-child(2) {
  min-width: 120px;
}

.preview-table th:nth-child(4), /* Milk Type */
.preview-table td:nth-child(4) {
  min-width: 90px;
}

.preview-table th:nth-child(5), /* Collection Time */
.preview-table td:nth-child(5) {
  min-width: 120px;
}

/* Numeric columns with right alignment */
.preview-table th:nth-child(3), /* Weight */
.preview-table td:nth-child(3),
.preview-table th:nth-child(6), /* Fat % */
.preview-table td:nth-child(6),
.preview-table th:nth-child(7), /* CLR */
.preview-table td:nth-child(7),
.preview-table th:nth-child(8), /* SNF % */
.preview-table td:nth-child(8),
.preview-table th:nth-child(9), /* Fat KG */
.preview-table td:nth-child(9),
.preview-table th:nth-child(10), /* SNF KG */
.preview-table td:nth-child(10),
.preview-table th:nth-child(11), /* Fat Rate */
.preview-table td:nth-child(11),
.preview-table th:nth-child(12), /* SNF Rate */
.preview-table td:nth-child(12),
.preview-table th:nth-child(13), /* Base SNF % */
.preview-table td:nth-child(13),
.preview-table th:nth-child(14), /* Milk Rate */
.preview-table td:nth-child(14) {
  text-align: right;
  min-width: 100px;
  padding-right: 30px;
}

/* Special styling for monetary values */
.preview-table td:nth-child(15) {
  font-weight: 600;
  color: #2e7d32;
  font-size: 16px;
}

/* Add more visual separation between groups of columns */
.preview-table th:nth-child(5), /* After Collection Time */
.preview-table td:nth-child(5) {
  border-right: 2px solid #ddd;
}

.preview-table th:nth-child(8), /* After SNF % */
.preview-table td:nth-child(8) {
  border-right: 2px solid #ddd;
}

.preview-table th:nth-child(12), /* After SNF Rate */
.preview-table td:nth-child(12) {
  border-right: 2px solid #ddd;
}

.preview-table th:nth-child(13), /* After Base SNF % */
.preview-table td:nth-child(13) {
  border-right: 2px solid #ddd;
}

.confirm-button,
.cancel-button {
  margin-left: 12px;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  font-size: 16px;
  gap: 8px;
}

.cancel-button {
  background: #f8f9fa;
  color: #3c4043;
  border: 1px solid #dadce0;
}

.cancel-button:hover {
  background: #f1f3f4;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);
}

.confirm-button {
  background: #1a73e8;
  color: white;
}

.confirm-button:hover {
  background: #1765cc;
  box-shadow: 0 1px 3px rgba(26, 115, 232, 0.4);
}

.confirm-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: #4d90fe;
  box-shadow: none;
}

/* Responsive styles for preview modal */
@media (max-width: 1200px) {
  .preview-modal {
    max-width: 95%;
    margin: 15px;
  }
  
  .preview-table {
    min-width: 800px;
  }
}

@media (max-width: 768px) {
  .preview-modal {
    width: 95%;
    max-height: 95vh;
    margin: 5px;
  }
  
  .preview-modal .modal-body {
    padding: 16px;
  }
  
  .preview-table th,
  .preview-table td {
    padding: 12px 10px;
    font-size: 16px;
  }
}

/* Customer selection in edit form */
.customer-select-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.customer-select-button {
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s ease;
}

.customer-select-button:hover {
  background-color: #2980b9;
}

.customer-select-container .edit-form-input {
  flex: 1 1;
}

/* Make customer modal appear above other modals */
.modal-overlay .customer-modal {
  z-index: 1010;
}

/* Modal header styling */
.preview-modal .modal-header {
  padding: 22px 28px;
  border-bottom: 1px solid #e8eaed;
  background-color: #f8f9fa;
}

.preview-modal .modal-header h2 {
  margin: 0;
  font-size: 1.7rem;
  color: #1976d2;
}

.collections-table td.customer-name-cell {
  text-align: left;
}

/* Collection Summary Statistics */
.collection-summary-stats {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  padding: 0;
  margin: 24px 0;
  overflow: hidden;
  border: 1px solid #e8eaed;
}

.summary-header {
  background-color: #f0f7ff;
  padding: 16px 20px;
  border-bottom: 1px solid #e8eaed;
  border-left: 4px solid #1976d2;
}

.summary-header h3 {
  margin: 0;
  color: #1976d2;
  font-size: 18px;
  font-weight: 600;
}

.stats-container {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  gap: 20px;
}

.stat-item {
  flex: 1 1;
  min-width: 180px;
  background-color: #f9fafc;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.04);
  border: 1px solid #eef1f6;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
}

.stat-label {
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 22px;
  font-weight: 600;
  color: #202124;
}

.stat-item:nth-child(1) .stat-value {
  color: #4338ca;
}

.stat-item:nth-child(2) .stat-value {
  color: #166534;
}

.stat-item:nth-child(3) .stat-value {
  color: #9a3412;
}

.stat-item:nth-child(4) .stat-value {
  color: #0369a1;
}

.stat-item:nth-child(5) .stat-value {
  color: #6b21a8;
}

.stat-item:nth-child(6) .stat-value {
  color: #047857;
}

.stat-item:nth-child(7) .stat-value {
  color: #b45309;
}

.stat-footer {
  background-color: #f8f9fa;
  padding: 16px 20px;
  border-top: 1px solid #e8eaed;
  text-align: right;
  font-size: 15px;
  color: #424242;
}

.final-amount {
  font-size: 20px;
  font-weight: 700;
  color: #1e8e3e;
}

@media (max-width: 768px) {
  .stats-container {
    flex-direction: column;
    padding: 15px;
  }
  
  .stat-item {
    width: 100%;
    min-width: unset;
  }
  
  .summary-header h3 {
    font-size: 16px;
  }
  
  .stat-value {
    font-size: 18px;
  }
  
  .final-amount {
    font-size: 18px;
  }
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 12px 20px;
  margin: 10px 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-message p {
  margin: 0;
  font-size: 16px;
} `, "",{"version":3,"sources":["webpack://./src/components/PreviewCollections.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,UAAU;EACV,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;;;IAIE,aAAa;EACf;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;;;;;;;;;;;;;;;;;;;;EAoBE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,yDAAyD;AACzD;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA,kDAAkD;AAClD;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB","sourcesContent":[".collections-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: #f8f9fa;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.collections-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.header-left,\n.header-right {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.header-right {\n  justify-content: flex-end;\n}\n\n.collections-header h1 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n  text-align: center;\n  flex: 2;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: #007bff;\n  font-size: 0.9rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n  padding: 0.5rem 0;\n}\n\n.back-button:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n.logout-button {\n  background: none;\n  border: none;\n  color: #dc3545;\n  font-size: 0.9rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0;\n}\n\n.logout-button:hover {\n  color: #c82333;\n  text-decoration: underline;\n}\n\n.collections-content {\n  flex: 1;\n  padding: 2rem;\n  max-width: 1500px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.collections-search {\n  margin-bottom: 1.5rem;\n}\n\n/* New filter styles */\n.collections-filters {\n  margin-bottom: 1.5rem;\n}\n\n.filter-options {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: 1rem;\n  gap: 1rem;\n}\n\n.filter-button {\n  background-color: #f8f9fa;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 0.5rem 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: #495057;\n  font-size: 0.9rem;\n}\n\n.filter-button:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.customer-filter-button {\n  background-color: #e9f2ff;\n  border-color: #b8daff;\n  color: #0062cc;\n}\n\n.customer-filter-button:hover {\n  background-color: #cce5ff;\n  border-color: #8bbeff;\n}\n\n.date-filter-button {\n  background-color: #e9fff2;\n  border-color: #b8ffd9;\n  color: #00a67c;\n}\n\n.date-filter-button:hover {\n  background-color: #ccffe7;\n  border-color: #8bffcc;\n}\n\n/* Add styles for sort order button */\n.sort-order-button {\n  background-color: #f2e9ff;\n  border-color: #d9b8ff;\n  color: #6200cc;\n}\n\n.sort-order-button:hover {\n  background-color: #e7ccff;\n  border-color: #cc8bff;\n}\n\n.active-filter {\n  display: flex;\n  align-items: center;\n  background-color: #e9f2ff;\n  border: 1px solid #b8daff;\n  border-radius: 4px;\n  padding: 0.5rem 1rem;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  color: #0062cc;\n}\n\n.active-filter.date-filter {\n  background-color: #e9fff2;\n  border-color: #b8ffd9;\n  color: #00a67c;\n}\n\n.active-filters-summary {\n  margin-top: 1rem;\n  padding: 0.75rem 1rem;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border-left: 4px solid #007bff;\n  font-size: 0.9rem;\n  color: #495057;\n}\n\n.active-filters-summary p {\n  margin: 0;\n}\n\n.filter-action-buttons {\n  display: inline-flex;\n  gap: 10px;\n  margin-left: 15px;\n}\n\n.clear-filter-button {\n  background: rgba(108, 117, 125, 0.1);\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.clear-filter-button:hover {\n  background-color: rgba(108, 117, 125, 0.2);\n  color: #495057;\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(2px);\n}\n\n.modal-content {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  backdrop-filter: none;\n}\n\n.customer-modal {\n  max-width: 600px;\n  background-color: white;\n  border: 1px solid #ddd;\n  padding: 0;\n}\n\n.date-filter-modal {\n  max-width: 500px;\n  background-color: white;\n  border: 1px solid #ddd;\n  padding: 0;\n}\n\n.modal-header {\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e9ecef;\n  background-color: #fff;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: #333;\n}\n\n.modal-close-button {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.modal-close-button:hover {\n  color: #343a40;\n}\n\n.customer-search-container {\n  padding: 20px;\n  border-bottom: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n}\n\n.date-filter-container {\n  padding: 20px;\n  background-color: white;\n}\n\n.date-input-group {\n  margin-bottom: 20px;\n}\n\n.date-input-group label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #495057;\n}\n\n.date-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.date-input:focus {\n  border-color: #00a67c;\n  box-shadow: 0 0 0 0.2rem rgba(0, 166, 124, 0.25);\n}\n\n.date-filter-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.date-filter-button {\n  padding: 10px 16px;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.date-filter-button.secondary {\n  background-color: #f8f9fa;\n  color: #6c757d;\n  border: 1px solid #ced4da;\n}\n\n.date-filter-button.secondary:hover {\n  background-color: #e9ecef;\n  color: #495057;\n}\n\n.date-filter-button.primary {\n  background-color: #00a67c;\n  color: white;\n}\n\n.date-filter-button.primary:hover {\n  background-color: #00916c;\n}\n\n.customers-list {\n  padding: 0;\n  overflow-y: auto;\n  max-height: 400px;\n  background-color: white;\n}\n\n.customer-item {\n  padding: 15px 20px;\n  border-bottom: 1px solid #e9ecef;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.customer-item:hover {\n  background-color: #f8f9fa;\n}\n\n.customer-item:last-child {\n  border-bottom: none;\n  margin-bottom: 10px;\n}\n\n.customer-name {\n  font-weight: 500;\n  color: #212529;\n}\n\n.customer-code {\n  color: #6c757d;\n  font-size: 0.85rem;\n  margin-top: 0.25rem;\n}\n\n.no-customers {\n  padding: 30px 20px;\n  text-align: center;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.search-wrapper {\n  position: relative;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #adb5bd;\n}\n\n.clear-search-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #adb5bd;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.clear-search-icon:hover {\n  color: #6c757d;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.75rem 1rem 0.75rem 2.5rem;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s;\n  padding-right: 2.5rem;\n}\n\n.search-input:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.collections-list {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n/* New table styles */\n.collections-table-container {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n  max-width: 100%;\n  margin-bottom: 1.5rem;\n  padding: 2px;\n  min-width: 1000px;\n}\n\n.collections-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: auto;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  font-size: 0.85rem;\n}\n\n.collections-table thead tr {\n  background-color: #f2f2f2;\n  border-bottom: 2px solid #ddd;\n}\n\n.collections-table th {\n  padding: 6px 8px;\n  font-weight: bold;\n  text-align: center;\n  position: sticky;\n  top: 0;\n  background-color: #f2f2f2;\n  z-index: 1;\n  border-right: 1px solid #ddd;\n  box-shadow: 0 1px 0 0 #ddd;\n  min-width: 80px;\n}\n\n.collections-table th:first-child {\n  border-left: 1px solid #ddd;\n}\n\n.collections-table tbody tr {\n  border-bottom: 1px solid #ddd;\n}\n\n.collections-table tbody tr:nth-child(even) {\n  background-color: #f8f8f8;\n}\n\n.collections-table tbody tr:hover {\n  background-color: #eaf3ff;\n}\n\n.collections-table td {\n  padding: 10px 15px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n  font-size: 16px;\n  font-weight: 500;\n  color: #181818;\n}\n\n.collections-table td:first-child {\n  border-left: 1px solid #ddd;\n}\n\n/* Column widths */\n.collections-table th:nth-child(1),\n.collections-table td:nth-child(1) {\n  min-width: 50px;\n  text-align: center;\n}\n\n.collections-table th:nth-child(2),\n.collections-table td:nth-child(2) {\n  min-width: 150px;\n  white-space: nowrap;\n}\n\n.collections-table th:nth-child(3),\n.collections-table td:nth-child(3) {\n  min-width: 80px;\n  text-align: right;\n}\n\n.collections-table th:nth-child(4),\n.collections-table td:nth-child(4) {\n  min-width: 55px !important;\n  max-width: 55px !important;\n  width: 55px !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.collections-table th:nth-child(5),\n.collections-table td:nth-child(5) {\n  min-width: 140px;\n  text-align: left;\n}\n\n.collections-table th:nth-child(n+6):nth-child(-n+14),\n.collections-table td:nth-child(n+6):nth-child(-n+14) {\n  min-width: 90px;\n  white-space: nowrap;\n  text-align: right;\n}\n\n.collections-table th:nth-child(15),\n.collections-table td:nth-child(15) {\n  min-width: 60px;\n  text-align: center;\n}\n\n/* Keep the collection-header and collection-item rules for backward compatibility */\n.collection-header {\n  display: flex;\n  background-color: #f1f3f5;\n  padding: 1rem;\n  font-weight: bold;\n  border-bottom: 1px solid #dee2e6;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  min-width: max-content;\n}\n\n.collection-item {\n  display: flex;\n  padding: 1rem;\n  border-bottom: 1px solid #e9ecef;\n  transition: background-color 0.2s;\n  min-width: max-content;\n}\n\n.collection-item:hover {\n  background-color: #f8f9fa;\n}\n\n.collection-item:last-child {\n  border-bottom: none;\n}\n\n.collection-column {\n  min-width: 100px;\n  padding: 0 0.5rem;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.collection-column:nth-child(1) {\n  min-width: 90px;\n}\n\n.collection-column:nth-child(2) {\n  min-width: 150px;\n}\n\n.collection-column:nth-child(3) {\n  min-width: 130px;\n}\n\n.collection-column:nth-child(4),\n.collection-column:nth-child(5),\n.collection-column:nth-child(6),\n.collection-column:nth-child(7),\n.collection-column:nth-child(8),\n.collection-column:nth-child(9) {\n  min-width: 80px;\n}\n\n.collection-column:nth-child(10),\n.collection-column:nth-child(11),\n.collection-column:nth-child(12),\n.collection-column:nth-child(13) {\n  min-width: 90px;\n}\n\n.error-message {\n  text-align: center;\n  padding: 2rem;\n  color: #dc3545;\n  background-color: #f8d7da;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.error-message button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  margin-top: 1rem;\n  cursor: pointer;\n}\n\n.error-message button:hover {\n  background-color: #c82333;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #007bff;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.no-collections {\n  text-align: center;\n  padding: 3rem;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.load-more {\n  text-align: center;\n  margin: 2rem 0;\n}\n\n.load-more-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 0.75rem 2rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.2s;\n  margin-bottom: 1rem;\n}\n\n.load-more-button:hover {\n  background-color: #0069d9;\n}\n\n.load-custom-options {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.load-custom-button {\n  background-color: #f8f9fa;\n  color: #007bff;\n  border: 1px solid #007bff;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.load-custom-button:hover {\n  background-color: #007bff;\n  color: white;\n}\n\n.collections-footer {\n  padding: 1rem;\n  text-align: center;\n  background-color: #fff;\n  border-top: 1px solid #e9ecef;\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n/* Responsive styles */\n@media (max-width: 1500px) {\n  .collections-table-container {\n    min-width: 1200px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .collections-content {\n    max-width: 100%;\n    padding: 1.5rem;\n  }\n  \n  .collections-table-container {\n    min-width: 1000px;\n  }\n}\n\n@media (max-width: 768px) {\n  .collections-header {\n    padding: 1rem;\n  }\n  \n  .collections-content {\n    padding: 1rem;\n  }\n  \n  .collections-table-container {\n    min-width: 900px;\n    border-radius: 6px;\n  }\n  \n  .collections-table th,\n  .collections-table td {\n    padding: 8px 10px;\n    font-size: 0.9rem;\n  }\n  \n  .collection-header,\n  .collection-item {\n    font-size: 0.85rem;\n  }\n  \n  .collections-header h1 {\n    font-size: 1.2rem;\n  }\n}\n\n/* Print styles for exporting to PDF/printing */\n@media print {\n  .collections-table-container {\n    overflow: visible;\n    width: 100%;\n    box-shadow: none;\n  }\n  \n  .collections-table {\n    width: 100%;\n    border: 1px solid #000;\n  }\n  \n  .collections-table th,\n  .collections-table td {\n    border: 1px solid #000;\n  }\n  \n  .collections-header,\n  .collections-footer,\n  .collections-search,\n  .load-more {\n    display: none;\n  }\n}\n\n/* Table action column styling */\n.actions-cell {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 5px;\n  min-width: 100px;\n}\n\n/* Edit Button in Collection Table */\n.edit-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 10px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  font-size: 14px;\n}\n\n.edit-button:hover {\n  background-color: #2980b9;\n}\n\n/* Delete Button in Collection Table */\n.delete-button {\n  background-color: #e74c3c;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 10px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  font-size: 14px;\n}\n\n.delete-button:hover {\n  background-color: #c0392b;\n}\n\n.delete-button:disabled {\n  background-color: #e57373;\n  cursor: not-allowed;\n}\n\n/* Confirmation Modal Styles */\n.confirmation-modal {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 500px;\n  overflow: hidden;\n}\n\n.confirmation-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.confirmation-modal .modal-header h3 {\n  margin: 0;\n  color: #e74c3c;\n  font-size: 1.25rem;\n}\n\n.confirmation-modal .modal-body {\n  padding: 20px;\n}\n\n.confirmation-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 20px;\n  background-color: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  gap: 10px;\n}\n\n.collection-delete-info {\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  padding: 15px;\n  margin: 15px 0;\n  border-left: 4px solid #e74c3c;\n}\n\n.collection-delete-info p {\n  margin: 5px 0;\n  font-size: 15px;\n}\n\n.warning-text {\n  color: #e74c3c;\n  font-weight: 500;\n  margin-top: 10px;\n}\n\n.cancel-button {\n  background-color: #f8f9fa;\n  color: #3c4043;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.cancel-button:hover {\n  background-color: #f1f3f4;\n  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);\n}\n\n.cancel-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Edit Collection Modal */\n.edit-collection-modal {\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.edit-collection-container {\n  padding: 15px;\n  background-color: #fff;\n}\n\n.edit-form-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.edit-form-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.edit-form-input {\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.edit-form-input.error {\n  border-color: #e74c3c;\n}\n\n.edit-input-error {\n  color: #e74c3c;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n.edit-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.edit-form-button {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.edit-form-button.cancel {\n  background-color: #f1f1f1;\n  color: #333;\n}\n\n.edit-form-button.save {\n  background-color: #27ae60;\n  color: white;\n}\n\n.edit-form-button.cancel:hover {\n  background-color: #e5e5e5;\n}\n\n.edit-form-button.save:hover {\n  background-color: #219653;\n}\n\n.edit-form-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.edit-form-error {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n.calculation-results {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.calculation-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 5px;\n}\n\n.calculation-item label {\n  font-weight: 500;\n  min-width: 70px;\n}\n\n.calculation-item span {\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.button-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Edit Form Button - Preview Button */\n.edit-form-button.preview {\n  background-color: #00a67c;\n  color: white;\n}\n\n.edit-form-button.preview:hover {\n  background-color: #00916c;\n}\n\n/* Preview Modal Styles */\n.preview-modal {\n  width: 95%;\n  max-width: 1400px;\n  max-height: 90vh;\n  overflow-y: auto;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.preview-modal .modal-body {\n  padding: 20px 30px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.preview-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px 30px;\n  border-top: 1px solid #e8eaed;\n  background-color: #f8f9fa;\n  gap: 15px;\n}\n\n.preview-header {\n  background-color: #f0f7ff;\n  padding: 15px 20px;\n  border-radius: 6px;\n  border-left: 4px solid #1976d2;\n  margin-bottom: 20px;\n}\n\n.preview-info {\n  font-size: 18px;\n  color: #424242;\n  margin: 0;\n  line-height: 1.6;\n}\n\n.preview-table-container {\n  overflow-x: auto;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border-radius: 6px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.preview-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n.preview-table th,\n.preview-table td {\n  padding: 16px 24px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n  white-space: nowrap;\n}\n\n/* Add alternating row colors for better readability */\n.preview-table tbody tr:nth-child(even) {\n  background-color: #f5f9ff;\n}\n\n.preview-table tbody tr:hover {\n  background-color: #eaf0fb;\n}\n\n/* Improve column spacing with min-width */\n.preview-table th {\n  background-color: #f0f5fa;\n  font-weight: 600;\n  color: #444;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  border-bottom: 2px solid #ddd;\n  min-width: 100px;\n  font-size: 17px;\n}\n\n/* Increase font size for table data */\n.preview-table td {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n/* Ensure certain columns have proper width */\n.preview-table th:nth-child(1), /* Customer name */\n.preview-table td:nth-child(1) {\n  min-width: 150px;\n}\n\n.preview-table th:nth-child(2), /* Date */\n.preview-table td:nth-child(2) {\n  min-width: 120px;\n}\n\n.preview-table th:nth-child(4), /* Milk Type */\n.preview-table td:nth-child(4) {\n  min-width: 90px;\n}\n\n.preview-table th:nth-child(5), /* Collection Time */\n.preview-table td:nth-child(5) {\n  min-width: 120px;\n}\n\n/* Numeric columns with right alignment */\n.preview-table th:nth-child(3), /* Weight */\n.preview-table td:nth-child(3),\n.preview-table th:nth-child(6), /* Fat % */\n.preview-table td:nth-child(6),\n.preview-table th:nth-child(7), /* CLR */\n.preview-table td:nth-child(7),\n.preview-table th:nth-child(8), /* SNF % */\n.preview-table td:nth-child(8),\n.preview-table th:nth-child(9), /* Fat KG */\n.preview-table td:nth-child(9),\n.preview-table th:nth-child(10), /* SNF KG */\n.preview-table td:nth-child(10),\n.preview-table th:nth-child(11), /* Fat Rate */\n.preview-table td:nth-child(11),\n.preview-table th:nth-child(12), /* SNF Rate */\n.preview-table td:nth-child(12),\n.preview-table th:nth-child(13), /* Base SNF % */\n.preview-table td:nth-child(13),\n.preview-table th:nth-child(14), /* Milk Rate */\n.preview-table td:nth-child(14) {\n  text-align: right;\n  min-width: 100px;\n  padding-right: 30px;\n}\n\n/* Special styling for monetary values */\n.preview-table td:nth-child(15) {\n  font-weight: 600;\n  color: #2e7d32;\n  font-size: 16px;\n}\n\n/* Add more visual separation between groups of columns */\n.preview-table th:nth-child(5), /* After Collection Time */\n.preview-table td:nth-child(5) {\n  border-right: 2px solid #ddd;\n}\n\n.preview-table th:nth-child(8), /* After SNF % */\n.preview-table td:nth-child(8) {\n  border-right: 2px solid #ddd;\n}\n\n.preview-table th:nth-child(12), /* After SNF Rate */\n.preview-table td:nth-child(12) {\n  border-right: 2px solid #ddd;\n}\n\n.preview-table th:nth-child(13), /* After Base SNF % */\n.preview-table td:nth-child(13) {\n  border-right: 2px solid #ddd;\n}\n\n.confirm-button,\n.cancel-button {\n  margin-left: 12px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s;\n  font-size: 16px;\n  gap: 8px;\n}\n\n.cancel-button {\n  background: #f8f9fa;\n  color: #3c4043;\n  border: 1px solid #dadce0;\n}\n\n.cancel-button:hover {\n  background: #f1f3f4;\n  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);\n}\n\n.confirm-button {\n  background: #1a73e8;\n  color: white;\n}\n\n.confirm-button:hover {\n  background: #1765cc;\n  box-shadow: 0 1px 3px rgba(26, 115, 232, 0.4);\n}\n\n.confirm-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background: #4d90fe;\n  box-shadow: none;\n}\n\n/* Responsive styles for preview modal */\n@media (max-width: 1200px) {\n  .preview-modal {\n    max-width: 95%;\n    margin: 15px;\n  }\n  \n  .preview-table {\n    min-width: 800px;\n  }\n}\n\n@media (max-width: 768px) {\n  .preview-modal {\n    width: 95%;\n    max-height: 95vh;\n    margin: 5px;\n  }\n  \n  .preview-modal .modal-body {\n    padding: 16px;\n  }\n  \n  .preview-table th,\n  .preview-table td {\n    padding: 12px 10px;\n    font-size: 16px;\n  }\n}\n\n/* Customer selection in edit form */\n.customer-select-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.customer-select-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.2s ease;\n}\n\n.customer-select-button:hover {\n  background-color: #2980b9;\n}\n\n.customer-select-container .edit-form-input {\n  flex: 1;\n}\n\n/* Make customer modal appear above other modals */\n.modal-overlay .customer-modal {\n  z-index: 1010;\n}\n\n/* Modal header styling */\n.preview-modal .modal-header {\n  padding: 22px 28px;\n  border-bottom: 1px solid #e8eaed;\n  background-color: #f8f9fa;\n}\n\n.preview-modal .modal-header h2 {\n  margin: 0;\n  font-size: 1.7rem;\n  color: #1976d2;\n}\n\n.collections-table td.customer-name-cell {\n  text-align: left;\n}\n\n/* Collection Summary Statistics */\n.collection-summary-stats {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n  padding: 0;\n  margin: 24px 0;\n  overflow: hidden;\n  border: 1px solid #e8eaed;\n}\n\n.summary-header {\n  background-color: #f0f7ff;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e8eaed;\n  border-left: 4px solid #1976d2;\n}\n\n.summary-header h3 {\n  margin: 0;\n  color: #1976d2;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.stats-container {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 20px;\n  gap: 20px;\n}\n\n.stat-item {\n  flex: 1;\n  min-width: 180px;\n  background-color: #f9fafc;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.04);\n  border: 1px solid #eef1f6;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.stat-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.08);\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #5f6368;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 22px;\n  font-weight: 600;\n  color: #202124;\n}\n\n.stat-item:nth-child(1) .stat-value {\n  color: #4338ca;\n}\n\n.stat-item:nth-child(2) .stat-value {\n  color: #166534;\n}\n\n.stat-item:nth-child(3) .stat-value {\n  color: #9a3412;\n}\n\n.stat-item:nth-child(4) .stat-value {\n  color: #0369a1;\n}\n\n.stat-item:nth-child(5) .stat-value {\n  color: #6b21a8;\n}\n\n.stat-item:nth-child(6) .stat-value {\n  color: #047857;\n}\n\n.stat-item:nth-child(7) .stat-value {\n  color: #b45309;\n}\n\n.stat-footer {\n  background-color: #f8f9fa;\n  padding: 16px 20px;\n  border-top: 1px solid #e8eaed;\n  text-align: right;\n  font-size: 15px;\n  color: #424242;\n}\n\n.final-amount {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1e8e3e;\n}\n\n@media (max-width: 768px) {\n  .stats-container {\n    flex-direction: column;\n    padding: 15px;\n  }\n  \n  .stat-item {\n    width: 100%;\n    min-width: unset;\n  }\n  \n  .summary-header h3 {\n    font-size: 16px;\n  }\n  \n  .stat-value {\n    font-size: 18px;\n  }\n  \n  .final-amount {\n    font-size: 18px;\n  }\n}\n\n.success-message {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  padding: 12px 20px;\n  margin: 10px 0;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.success-message p {\n  margin: 0;\n  font-size: 16px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
